import { cn } from "@/lib/helpers/cn";
import { Heading2 } from "@/ui2/atoms/Heading";

type Props = { title: string };

export function ContainerTitle({ title }: Props) {
  return (
    <Heading2
      as="h1"
      className={cn(
        "tw:text-text-secondary",
        "tw:max-md:!-mb-1 tw:md:!-mb-2", // optical alignment
      )}
      size={3}
    >
      {title}
    </Heading2>
  );
}
